import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  footer: {
    borderRadius: 15,
    margin: '30px 0',
    padding:'20px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  circleLink:{
    background:'lightgrey',
    margin:'0 20px',
    borderRadius:'50%',
    padding:'5px'
  }
});
